// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  padding: 0 12px;
  --background: var(--account-toolbar-background);
  --box-shadow: none;
}
ion-toolbar ion-icon {
  height: 19px;
  width: 19px;
}
ion-toolbar ion-title {
  font-family: AppFontMedium, sans-serif !important;
  text-transform: uppercase;
  color: var(--color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-toolbar/account-toolbar.component.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,+CAAA;EACA,kBAAA;AACD;AAAC;EACC,YAAA;EACA,WAAA;AAEF;AAAC;EACC,iDAAA;EACA,yBAAA;EACA,yBAAA;AAEF","sourcesContent":["ion-toolbar {\n\tpadding: 0 12px;\n\t--background: var(--account-toolbar-background);\n\t--box-shadow: none;\n\tion-icon {\n\t\theight: 19px;\n\t\twidth: 19px;\n\t}\n\tion-title {\n\t\tfont-family: AppFontMedium, sans-serif !important;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--color-black);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
